/**
 * Cliente Supabase singleton.
 *
 * Se inicializa una sola vez con `VITE_SUPABASE_URL` + `VITE_SUPABASE_ANON_KEY`
 * y se reusa en todo el frontend. La lib maneja:
 *
 * - Persistencia de sesión en localStorage.
 * - Refresh automático del access_token antes de que expire.
 * - Pub/sub de cambios de auth (lo escuchamos en `AuthProvider`).
 *
 * Si alguna variable falta, lanzamos un error descriptivo en dev para
 * detectar el misconfigured temprano (no queremos un 401 misterioso).
 */
import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    "Faltan VITE_SUPABASE_URL o VITE_SUPABASE_ANON_KEY en tu .env.local. " +
      "Copialos desde Supabase Dashboard → Settings → Data API / API Keys. " +
      "Ver frontend/.env.example.",
  );
}

export const supabase: SupabaseClient = createClient(url, anonKey, {
  auth: {
    // Mantiene la sesión en localStorage entre reloads (default true).
    persistSession: true,
    // Refresh automático del access_token cuando faltan pocos min de expirar.
    autoRefreshToken: true,
    // Detección de sesión recuperada en URL (para flujos de magic link / oauth).
    detectSessionInUrl: true,
  },
});
